import ArrowBackButtonView from './ArrowBackButton.view';
export default ArrowBackButtonView;
